// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8d324b26","97":"e65fe908","102":"01bf39b4","110":"ed6f208b","440":"96838017","561":"35ee25e9","635":"650426b9","683":"1b24da05","685":"7209129f","703":"b8e33c78","876":"947dbf41"}[chunkId] + ".chunk.js";
};